import React, { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { MemoryRouter, useLocation } from 'react-router';
import { ModalHeader } from '../../../components/common/ModalHeader';
import { ActionName } from '../../../constants/Bi';
import { ModalName } from '../../../constants/ModalName';
import { useFileType } from '../../../utils/hooks/bi/useFileType';
import { useTrackActions } from '../../../utils/hooks/bi/useTrackActions';
import { useModal, useModalHandlersAndOptions } from '../../../utils/hooks/useModal';
import { ModalFilesManager } from '../../ModalFilesManager';

const itemsLoaderConfig = { foldersOnly: true, ignoreSearch: true };
export const useMoveToModal = ({ selectedItems, folderPath, moveSelectedItems, handleFolderCreateInMoveToModal }) => {
  const fileType = useFileType();

  const { pathname } = useLocation();
  const initialEntries = useMemo(() => [pathname], [pathname]);

  const { closeModal: closeMoveToModal } = useModalHandlersAndOptions(ModalName.MoveTo);

  const { trackActionsDone } = useTrackActions();
  const trackMoveToModalClose = useCallback(() => {
    trackActionsDone(selectedItems, ActionName.MoveTo);
  }, [trackActionsDone, selectedItems]);

  const handleMoveClick = useCallback(
    (destination) => {
      moveSelectedItems(destination);
      closeMoveToModal();
      trackMoveToModalClose();
    },
    [moveSelectedItems, closeMoveToModal, trackMoveToModalClose],
  );

  return useModal(ModalName.MoveTo, {
    customLayout: true,
    title: <ModalHeader title={<FormattedMessage id="actions.move-to" />} />,
    content: (
      <MemoryRouter initialEntries={initialEntries}>
        <ModalFilesManager
          fileType={fileType}
          sourceItems={selectedItems}
          itemsLoaderConfig={itemsLoaderConfig}
          initialFolderPath={folderPath}
          onFolderCreate={handleFolderCreateInMoveToModal}
          onMoveClick={handleMoveClick}
        />
      </MemoryRouter>
    ),
    hideFooter: true,
    shouldCloseOnOverlayClick: true,
    noBodyPadding: true,
  });
};
